import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AudienceFilter, DiscoverAudienceFilter} from '../../../../../models/discover';
import {AchooSliderComponent} from '../../../../core/achoo-slider/achoo-slider.component';
import {ReferenceDataService} from '../../../../services/reference-data/reference-data.service';
import {TranslateService} from '@ngx-translate/core';
import { AchooFilterBoxComponent } from '../../../../core/achoo-filter-box/achoo-filter-box.component';
import {InterestFilterComponent} from '../interest-filter/interest-filter.component';
import {FilterRange} from '../../../../../models/group-search';

@Component({
  selector: 'audience-filter',
  templateUrl: './audience-filter.component.html',
  styleUrls: ['./audience-filter.component.scss']
})
export class AudienceFilterComponent implements OnInit {
  static readonly minSearchValue = 0;
  static readonly maxSearchValue = 100;
  static AGE_RANGES = [ 'from13to17', 'from18to24', 'from25to34', 'from35to44', 'from45to64', 'from65' ];
  @Input() audienceSearchCriteria: DiscoverAudienceFilter;
  @Output()
  public searchByAudienceFilter = new EventEmitter<DiscoverAudienceFilter>();
  @Output()
  public clearAudienceFilterEvent = new EventEmitter<DiscoverAudienceFilter>();
  @Output()
  public hideAudienceFilterEvent = new EventEmitter<any>();

  @ViewChild('genderRangeSlider')
  genderRangeSlider: AchooSliderComponent;
  @ViewChild('ageRangeSlider')
  ageRangeSlider: AchooSliderComponent;
  @ViewChild('countryRangeSlider')
  countryRangeSlider: AchooSliderComponent;
  @ViewChild('genderFilterBox')
  genderFilterBox: AchooFilterBoxComponent;
  @ViewChild('ageFilterBox')
  ageFilterBox: AchooFilterBoxComponent;
  @ViewChild('countryFilterBox')
  countryFilterBox: AchooFilterBoxComponent;

  public countryList;
  public genderList;
  public ageRangeList;

  public minValue = 0;
  public maxValue = 100;
  public fromGender;
  public toGender;
  public fromAge;
  public toAge;
  public fromCountry;
  public toCountry;

  constructor(private referenceDataService: ReferenceDataService,
              private translate: TranslateService) {
    this.countryList = this.referenceDataService.countries.map(c => ({
      id: c.code,
      name: c.name
    }));
    this.genderList = [
      {id: 'female', name: this.translate.instant('common.gender.female')},
      {id: 'male', name: this.translate.instant('common.gender.male')}
    ];
    this.ageRangeList = AudienceFilterComponent.AGE_RANGES.map(range => ({
      id: range,
      name: this.translate.instant(`common.age_range.${range}`)
    }));
  }

  ngOnInit() {
    if (!this.audienceSearchCriteria) {
      this.initAudienceFilterValues();
    } else {
      this.fromGender = this.audienceSearchCriteria.gender.range.from;
      this.toGender = this.audienceSearchCriteria.gender.range.to;
      this.fromAge = this.audienceSearchCriteria.age.range.from;
      this.toAge = this.audienceSearchCriteria.age.range.to;
      this.fromCountry = this.audienceSearchCriteria.country.range.from;
      this.toCountry = this.audienceSearchCriteria.country.range.to;
    }
  }

  doSearchByAudienceFilter() {
    this.searchByAudienceFilter.emit(this.audienceSearchCriteria);
  }

  resetAudienceFilters() {
    this.resetAudienceFilter();
    // emit event clear
    this.clearAudienceFilterEvent.emit(this.audienceSearchCriteria);
  }

  resetAudienceFilter() {
    // reset criteria
    this.initAudienceFilterValues();
    // reset slider element
    this.genderRangeSlider.resetSlider();
    this.genderRangeSlider.sliderElement.reset();
    this.ageRangeSlider.resetSlider();
    this.ageRangeSlider.sliderElement.reset();
    this.countryRangeSlider.resetSlider();
    this.countryRangeSlider.sliderElement.reset();

    this.clearAudienceFilterEvent.emit();
  }

  private initAudienceFilterValues() {
    this.audienceSearchCriteria = new DiscoverAudienceFilter();
    this.audienceSearchCriteria.gender.range = new FilterRange(AudienceFilterComponent.minSearchValue, AudienceFilterComponent.maxSearchValue);
    this.audienceSearchCriteria.age.range = new FilterRange(AudienceFilterComponent.minSearchValue, AudienceFilterComponent.maxSearchValue);
    this.audienceSearchCriteria.country.range = new FilterRange(AudienceFilterComponent.minSearchValue, AudienceFilterComponent.maxSearchValue);
    this.fromGender = this.fromAge = this.fromCountry = AudienceFilterComponent.minSearchValue;
    this.toGender = this.toAge = this.toCountry = AudienceFilterComponent.maxSearchValue;
  }

  onClickedOutside(e) {
    this.hideAudienceFilterEvent.emit(this.audienceSearchCriteria);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/audience-filter/audience-filter.component.ts